export default {
  appLogo: null,
  appLogoPath: "",
  browserIconPath: "",
  browserIcon: null,
};
